import { useReducer } from "react";
import IconCommunity from "ui/icons/IconCommunity";
import IconDivision from "ui/icons/IconDivision";
import IconPhase from "ui/icons/IconPhase";
import IconRegion from "ui/icons/IconRegion";
import TreeSelect from "./TreeSelect";
import { initializeTreeState, treeReducer } from "./treeSelectReducer";
import type { TreeSelectNodeType } from "./treeSelectTypes";

// Mock data generator
const createMockData = (): TreeSelectNodeType[] => [
  {
    id: "alabama",
    name: "Alabama",
    label: "Alabama",
    selected: false,
    icon: <IconRegion />,
    children: [
      {
        id: "birmingham",
        name: "Birmingham",
        label: "Birmingham",
        selected: false,
        icon: <IconDivision />,
        children: [
          {
            id: "downtown-community",
            name: "Downtown Community",
            label: "Downtown Community",
            selected: false,
            icon: <IconCommunity />,
            children: [],
          },
        ],
      },
    ],
  },
  {
    id: "florida",
    name: "Florida",
    label: "Florida",
    selected: false,
    icon: <IconRegion />,
    children: [
      {
        id: "jacksonville",
        name: "Jacksonville",
        label: "Jacksonville",
        selected: false,
        icon: <IconDivision />,
        children: [],
      },
      {
        id: "melbourne",
        name: "Melbourne",
        label: "Melbourne",
        selected: false,
        icon: <IconDivision />,
        children: [],
      },
      {
        id: "orlando",
        name: "Orlando",
        label: "Orlando",
        selected: false,
        icon: <IconDivision />,
        children: [
          {
            id: "daytona-beach",
            name: "Daytona Beach",
            label: "Daytona Beach",
            selected: false,
            icon: <IconCommunity />,
            children: [
              {
                id: "phase-1a",
                name: "Phase 1",
                label: "Phase 1",
                selected: false,
                icon: <IconPhase />,
                children: [],
              },
              {
                id: "phase-2b",
                name: "Phase 2",
                label: "Phase 2",
                selected: false,
                icon: <IconPhase />,
                children: [],
              },
            ],
          },
        ],
      },
      {
        id: "ocean-view",
        name: "Ocean View",
        label: "Ocean View",
        selected: false,
        icon: <IconDivision />,
        children: [
          {
            id: "hidden-cove",
            name: "Hidden Cove",
            label: "Hidden Cove",
            selected: false,
            icon: <IconCommunity />,
            children: [
              {
                id: "phase-1",
                name: "Phase 1",
                label: "Phase 1",
                selected: false,
                icon: <IconPhase />,
                children: [],
              },
              {
                id: "phase-2",
                name: "Phase 2",
                label: "Phase 2",
                selected: false,
                icon: <IconPhase />,
                children: [],
              },
            ],
          },
        ],
      },
      {
        id: "deland",
        name: "Deland",
        label: "Deland",
        selected: false,
        icon: <IconDivision />,
        children: [],
      },
    ],
  },
  {
    id: "haines-county",
    name: "Haines County",
    label: "Haines County",
    selected: false,
    icon: <IconRegion />,
    children: [],
  },
  {
    id: "lake-county",
    name: "Lake County",
    label: "Lake County",
    selected: false,
    icon: <IconRegion />,
    children: [],
  },
];

export function WithSelectionExample() {
  const [treeData, dispatch] = useReducer(treeReducer, createMockData(), initializeTreeState);

  const handleSelect = (id: string, checked: boolean | "indeterminate") => {
    dispatch({ type: "TOGGLE_NODE", id, checked });
  };

  return (
    <div style={{ padding: "20px" }}>
      <h3>Tree with Selection</h3>
      <TreeSelect treeData={treeData} onSelect={handleSelect} />
    </div>
  );
}

export default function TreeSelectExamples() {
  return (
    <div>
      <h1>TreeSelect Examples</h1>
      <WithSelectionExample />
    </div>
  );
}
